import { _ as _objectSpread2 } from './objectSpread2-c1340c1c.esm.js';
import { initVal as initVal$1, Internal as Internal$1 } from '@valbuild/core';
import * as core from '@valbuild/core';
export { core as expr };
export { FILE_REF_PROP, GenericSelector, Schema, VAL_EXTENSION, derefPatch, modules } from '@valbuild/core';
import { stegaClean, stegaDecodeString, autoTagJSX } from '@valbuild/react/stega';
export { ValRichText } from '@valbuild/react/internal';
import { ValNextProvider } from './ValNextProvider-5f8b7338.esm.js';
import NextImage from 'next/image';
import { jsx } from 'react/jsx-runtime';
export { ValApp } from './ValApp-3ab62a2b.esm.js';
import { V as VERSION } from './version-98ec5c7a.esm.js';

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function raw(encodedString) {
  return stegaClean(encodedString);
}

function decodeValPathOfString(encodedString) {
  return stegaDecodeString(encodedString);
}

var initVal = function initVal(config) {
  var _createValSystem = initVal$1(config),
    s = _createValSystem.s,
    c = _createValSystem.c,
    val = _createValSystem.val,
    systemConfig = _createValSystem.config;
  var currentConfig = _objectSpread2(_objectSpread2({}, systemConfig), config);
  return {
    s: s,
    c: c,
    val: _objectSpread2(_objectSpread2({}, val), {}, {
      attrs: function attrs(target) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var anyTarget = target;
        var path;
        if (target === null) {
          return {};
        }
        path = Internal$1.getValPath(anyTarget);
        if (!path && _typeof(anyTarget) === "object") {
          path = anyTarget["valPath"];
        }
        if (typeof anyTarget === "string") {
          path = decodeValPathOfString(anyTarget);
        }
        if (path) {
          return {
            "data-val-path": path
          };
        }
        return {};
      },
      unstable_decodeValPathOfString: decodeValPathOfString,
      raw: raw
    }),
    config: currentConfig
  };
};

var ValProvider = ValNextProvider;

function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}

function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}

var _excluded = ["src", "alt", "style", "width", "disableHotspot", "height"];
function ValImage(props) {
  var _src$metadata, _src$metadata2, _src$metadata3, _src$metadata4, _src$metadata5, _src$metadata6;
  var src = props.src,
    alt = props.alt,
    style = props.style,
    width = props.width,
    disableHotspot = props.disableHotspot,
    height = props.height,
    rest = _objectWithoutProperties(props, _excluded);
  var valPathOfUrl = decodeValPathOfString(src.url);
  var valPaths = [valPathOfUrl];
  var maybeValPathOfAlt = decodeValPathOfString(alt);
  if (maybeValPathOfAlt) {
    valPaths.push(maybeValPathOfAlt);
  }
  var hotspot = (_src$metadata = src.metadata) === null || _src$metadata === void 0 ? void 0 : _src$metadata.hotspot;
  var imageStyle = hotspot && !disableHotspot ? _objectSpread2(_objectSpread2({}, style), {}, {
    objectPosition: "".concat(hotspot.x * 100, "% ").concat(hotspot.y * 100, "%")
  }) : style;
  var preferMetadataDims = src.metadata !== undefined && !rest.fill && !width && !height;
  var isUnoptimized = rest.unoptimized !== undefined ? rest.unoptimized : ((_src$metadata2 = src.metadata) === null || _src$metadata2 === void 0 ? void 0 : _src$metadata2.mimeType) === "image/svg+xml"; // SVGs are unoptimized by default
  return /*#__PURE__*/jsx(NextImage, _objectSpread2(_objectSpread2({}, _objectSpread2(_objectSpread2({}, rest), {}, {
    layout: undefined,
    objectFit: undefined,
    objectPosition: undefined,
    lazyBoundary: undefined,
    lazyRoot: undefined
  })), {}, {
    src: valPathOfUrl ? raw(src.url) : src.url,
    "data-val-path": valPaths.join(","),
    "data-val-attr-alt": maybeValPathOfAlt,
    "data-val-attr-src": valPathOfUrl,
    style: imageStyle,
    alt: alt ? raw(alt) : (_src$metadata3 = src.metadata) !== null && _src$metadata3 !== void 0 && _src$metadata3.alt ? raw((_src$metadata4 = src.metadata) === null || _src$metadata4 === void 0 ? void 0 : _src$metadata4.alt) : "",
    fill: rest.fill,
    width: preferMetadataDims ? (_src$metadata5 = src.metadata) === null || _src$metadata5 === void 0 ? void 0 : _src$metadata5.width : width,
    height: preferMetadataDims ? (_src$metadata6 = src.metadata) === null || _src$metadata6 === void 0 ? void 0 : _src$metadata6.height : height,
    unoptimized: isUnoptimized
  }));
}

// NOTE! Side effects:
autoTagJSX();

// Convenience types

var Internal = _objectSpread2(_objectSpread2({}, Internal$1), {}, {
  VERSION: _objectSpread2(_objectSpread2({}, Internal$1.VERSION), {}, {
    next: VERSION
  })
});

export { Internal, ValImage, ValProvider, initVal };
